import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import StringField from 'Common/Components/StringField';
import {
  setField, addPolicy, removePolicy, addReference,
  removeReference, addCVE, removeCVE
} from 'Screens/Contextualization/KnowledgeBaseEditCreate/actions/Actions';
import {
  selectTemplateEditCreate,
  selectPermissions,
  selectReadonly
} from 'store/KnowledgeBase/selectors';
import SeverityDropdown from 'Common/Components/SeverityDropdown';
import EORDropdown from 'Common/Components/EORDropdown';
import CustomList from 'Common/Components/CustomList';
import Impacts from 'Common/Components/Impacts';
import {
  Wrapper, DropdownsContainer, RedDot, Black, Row, LeftColumn, RightColumn, Box
} from './styled';
import MarkdownInput from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal/components/MarkdownInput';
import CVE from './InputCVE';

const General = () => {
  const dispatch = useDispatch();
  const props = useSelector((state) => ({ ...selectReadonly(state), ...selectPermissions(state), ...selectTemplateEditCreate(state) }));

  const saveData = (field, value) => {
    dispatch(setField(field, value));
  };

  const setCVE = (val) => {
    dispatch(addCVE(val));
  };
  const removeCVEFromKB = (val) => {
    dispatch(removeCVE(val));
  };

  const impacts = {
    accountability: props.accountability,
    availability: props.availability,
    confidentiality: props.confidentiality,
    integrity: props.integrity
  };

  return (
    <Wrapper>
      <Row className="ml-0 mr-0">
        <StringField
          className="mr-17"
          width="405px"
          height="38px"
          placeholder="Vulnerability template name"
          defaultValue={ props.name }
          onChange={ (value) => saveData('name', value) }
          title={ (
            <RedDot>
              <Black>Name</Black>
              {' '}
              *
            </RedDot>
) }
        />
        <DropdownsContainer>
          <SeverityDropdown updateValue={ (field, value) => saveData('exploitation', value) } defaultValue={ props.exploitation } context />
          <EORDropdown updateValue={ (field, value) => saveData('easeofresolution', value) } defaultValue={ props.easeofresolution } />
        </DropdownsContainer>
      </Row>

      <Row className="ml-0 mr-0 margin-top-26">
        <LeftColumn>
          <Box>
            <MarkdownInput
              title="Description"
              value={ props.description }
              onBlur={ (value) => saveData('description', value) }
            />
          </Box>
        </LeftColumn>
        <RightColumn>
          <Box>
            <MarkdownInput
              title="Resolution"
              value={ props.resolution }
              onBlur={ (value) => saveData('resolution', value) }
            />
          </Box>
        </RightColumn>
      </Row>

      <Row className="ml-0 mr-0 margin-top-26">
        <LeftColumn>
          <StringField width="100%" height="38px" placeholder="125798926" title="External ID" value={ props.external_id } onChange={ (value) => dispatch(setField('external_id', value)) } defaultValue={ props.external_id } />
        </LeftColumn>
        <RightColumn>
          <Impacts
            selectCheckbox={ (field) => saveData(field, !props[field]) }
            impacts={ impacts }
            margin={ false }
          />
        </RightColumn>
      </Row>

      <Row className="ml-0 mr-0 margin-top-26">
        <LeftColumn>
          <CustomList
            key="CL_POLICY_VIOLATIONS"
            title="Policy Violations"
            placeholder="Add a Policy Violation"
            addItem={ () => dispatch(addPolicy()) }
            removeItem={ (index) => dispatch(removePolicy(index)) }
            setItem={ (value) => saveData('policy', value) }
            listData={ props.policyviolations }
            responsive
          />
        </LeftColumn>
        <RightColumn>
            <CustomList
              key="CL_REFERENCES"
              title="References"
              placeholder="Add a Reference"
              addItem={ () => dispatch(addReference()) }
              removeItem={ (index) => dispatch(removeReference(index)) }
              setItem={ (value) => dispatch(setField('reference', value)) }
              listData={ props.references }
              responsive
            />
        </RightColumn>
      </Row>
      <Row className="ml-0 mr-0 margin-top-26">
        <CVE
          listData={ props.cve }
          onAdd= { setCVE }
          onRemove={ removeCVEFromKB }
        />
      </Row>

    </Wrapper>
  );
};

export default withRouter(General);
